import { useTranslation } from "react-i18next";
import useClientConfig from "../common/hooks/clientConfigHook"
import { Col, Row } from "../common/components/Grid";
import TextInput from "../common/components/TextInput";
import GridInput from "./GridInput";
import PositionInput from "./PositionInput";
import SiteDropdown from "./SiteDropdown";
import LevelDropdown from "./LevelDropdown";
import TypeDropdown from "./TypeDropdown";
import ColorPicker from "../common/components/ColorPicker";
import IconPicker from "../common/components/IconPicker";
import Checkbox from "../common/components/Checkbox";
import CustomForm from "../common/components/CustomForm";
import DataTable from "../common/components/DataTable";
import { useMemo } from "react";
import Card from "../common/components/Card";

const LocationDetails = ({ location, disabled, readonly, onChange }) => {
    const { t } = useTranslation();
    const clientConfig = useClientConfig();

    const activeTimesDef = useMemo(() => [
        { type: 'date', field: 'start', title: t('startDate'), required: true, editable: true },
        { type: 'time', field: 'start', title: t('startTime'), required: true, editable: true },
        { type: 'date', field: 'end', title: t('endDate'), required: true, editable: true },
        { type: 'time', field: 'end', title: t('endTime'), required: true, editable: true },
    ], [t]);

    return <div style={{ height: '100%', overflowY: 'auto' }}>
        <Row>
            <Col><TextInput value={location.name} placeholder={t('name')} required disabled={disabled} readonly={readonly} onChange={name => onChange({ name })}></TextInput></Col>
            <Col><TextInput value={location.group} placeholder={t('group')} disabled={disabled} readonly={readonly} onChange={group => onChange({ group })}></TextInput></Col>
            <Col><TextInput value={location.subgroup} placeholder={t('subgroup')} disabled={disabled} readonly={readonly} onChange={subgroup => onChange({ subgroup })}></TextInput></Col>
        </Row>
        { clientConfig.enableGrid && <Row>
            <Col><GridInput gridx={location.gridx} gridy={location.gridy} disabled={disabled} readonly={readonly} placeholder={t('grid')} onChange={onChange}></GridInput></Col>
        </Row> }
        { clientConfig.enableLoc && <Row>
            <Col><PositionInput position={({latitude: location.lat, longitude: location.long, w3w: location.w3w})} disabled={disabled} readonly={readonly} onChange={onChange} disableRevCode></PositionInput></Col>
        </Row> }
        <Row>
            {clientConfig.enableSites ? <Col><SiteDropdown disabled={disabled} readonly={readonly} site={location.site} level={location.level} type={location.type} wildcard={t('anyWildcard')} strict={false} onChange={onChange}></SiteDropdown></Col> : null}
            {clientConfig.enableLevels ? <Col><LevelDropdown disabled={disabled} readonly={readonly} site={location.site} level={location.level} type={location.type} wildcard={t('anyWildcard')} strict={false} onChange={onChange}></LevelDropdown></Col> : null}
            <Col><TypeDropdown disabled={disabled} readonly={readonly} site={location.site} level={location.level} type={location.type} wildcard={t('anyWildcard')} strict={false} onChange={onChange}></TypeDropdown></Col>
        </Row>
        <Row>
            <Col><ColorPicker disabled={disabled} readonly={readonly} value={location.color} onChange={color => onChange({ color })} placeholder={t('color')} required></ColorPicker></Col>
            <Col><IconPicker disabled={disabled} readonly={readonly} value={location.icon} onChange={icon => onChange({ icon })} placeholder={t('icon')} required></IconPicker></Col>
            <Col><Checkbox disabled={disabled} readonly={readonly} checked={location.hidden} placeholder={t('hidden')} onChange={hidden => onChange({ hidden })}></Checkbox></Col>
        </Row>
        { clientConfig.locationCustomFields && <Row>
            <Col>
                <CustomForm def={clientConfig?.locationCustomFields} data={location.customfields ?? {}} onChange={customfields => onChange({ customfields })} disabled={disabled} readonly={readonly} required></CustomForm>
            </Col>
        </Row> }
        { clientConfig.locationTimes?.enable && <Row>
            <Col>
                <Card title={t('activeTimes')}>
                    <DataTable value={location.activetimes ?? []} emptyMessage={t('alwaysActive')} columns={activeTimesDef} defaultSort={['start']} onChange={activetimes => onChange({ activetimes })}></DataTable>
                </Card>
            </Col>
        </Row>}
</div>
}
export default LocationDetails;